// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3hu9d","title":"Images90_title__2XMCr","images":"Images90_images__Ri_UG"};